import ShiftBlock from './ShiftBlock';
import { PERIODS } from './shiftPeriods';

const ShiftBlocks = ({ entries, userId, isDirector, isMobile, expandedEntries, toggleExpand, onOpenAdd, onOpenEdit }) => {
  const descrizioni = (entries || []).filter(en => en.entry_type === 'descrizione' && en.shift_period);

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 12 }}>
        {PERIODS.map(period => {
          const periodEntries = descrizioni.filter(d => d.shift_period === period.key);
          const ownEntry = periodEntries.find(d => String(d.user_id) === String(userId));
          return (
            <ShiftBlock
              key={period.key}
              period={period}
              periodEntries={periodEntries}
              ownEntry={ownEntry}
              isDirector={isDirector}
              userId={userId}
              expandedEntries={expandedEntries}
              toggleExpand={toggleExpand}
              onOpenAdd={() => onOpenAdd(period.key)}
              onOpenEdit={onOpenEdit}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ShiftBlocks;
